import {PersonType, Profile, Role} from "@betrue/shared/interfaces";
import {gql, useReactiveVar} from "@apollo/client";
import {makeVarPersisted} from "@betrue/shared/utils";

const initialProfile: Profile = {
  available: false,
  completion: 0,
  removed: false,
  publicConsent: false,
  internalConsent: false,
  person: {
    role:Role.USER,
    removed: false,
    id: undefined,
    firstName: '',
    hasAvatar: false,
    lastName: '',
    externalId: '',
    scope: undefined,
    jobTitle: '',
    email: '',
    phone: '',
    profile: undefined,
    chatUsername:undefined,
    chatId:undefined,
    personType: PersonType.PHYSICAL
  },
  portfolio: '',
  description: undefined,
  id: '',
  job: undefined,
  experienceLevel: undefined,
  rating: 0,
  canRead: true,
  skills: [],
  mainsSkills: [],
  price: 0
}

const profileVar = makeVarPersisted<Profile>(initialProfile, 'profileVar')

const useProfile = (): [Profile, (Profile) => void] => {
  return [
    useReactiveVar<Profile>(profileVar), (p: Profile) => {
      profileVar(p)
    }]
}

export const GET_PROFILE = gql`
  query GetProfile {
    profile @client
  }
`;

export const profileStore = {
  profile: {
    read() {
      return profileVar()
    }
  }
}
